export default "__VITE_PUBLIC_ASSET__09225623__"